// Copyright (c) 2026 Aravind Adari. All rights reserved.

import { Paper, Box, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";

interface Props {
  icon?: ReactNode;
  value: string | number;
  label: string;
  color: string;
}

export default function SummaryCard({ icon, value, label, color }: Props) {
  const theme = useTheme();
  const bgAlpha = theme.palette.mode === "light" ? "22" : "33";

  return (
    <Paper
      elevation={2}
      sx={{
        p: 2.5,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flex: "1 1 200px",
        minWidth: 200,
        transition: "transform 0.2s",
        "&:hover": { transform: "translateY(-2px)" },
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          bgcolor: `${color}${bgAlpha}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color,
          flexShrink: 0,
          "& .MuiSvgIcon-root": { fontSize: 28 },
        }}
      >
        {icon}
      </Box>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: 700, fontSize: "1.5rem", lineHeight: 1.2 }}>
          {value}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      </Box>
    </Paper>
  );
}
